<div
  class="selected-item-list"
  *ngIf="items?.length"
  [class.selected-item-list--expandable]="!!itemBodyTpl"
>
  <ng-container *ngFor="let item of items; trackBy: trackById; let i = index">
    <mat-expansion-panel
      *ngIf="itemBodyTpl; else simpleRow"
      class="selected-item-list__panel"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="selected-item-list__title">
          <ng-container
            *ngTemplateOutlet="rowInner; context: { $implicit: item, index: i }"
          ></ng-container>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container
        *ngTemplateOutlet="itemBodyTpl; context: { $implicit: item, index: i }"
      ></ng-container>
    </mat-expansion-panel>
    <ng-template #simpleRow>
      <div
        class="selected-item-list__row"
        [attr.data-testid]="'selected-item-' + item.id"
      >
        <ng-container
          *ngTemplateOutlet="rowInner; context: { $implicit: item, index: i }"
        ></ng-container>
      </div>
    </ng-template>
  </ng-container>
</div>

<ng-template #rowInner let-item let-index="index">
  <app-checkbox
    [inputId]="'SELECTED_ITEM_' + item.id"
    labelClass="mb-0"
    [checked]="true"
    [stopClickPropagation]="true"
    size="sm"
    (changeEvent)="onCheckboxChange($event, item)"
  ></app-checkbox>
  <div class="selected-item-list__content">
    <ng-container
      *ngIf="itemLabelTpl; else defaultName"
      [ngTemplateOutlet]="itemLabelTpl"
      [ngTemplateOutletContext]="{ $implicit: item, index: index }"
    ></ng-container>
    <ng-template #defaultName>
      <span class="selected-item-list__name">{{ item.name }}</span>
    </ng-template>
  </div>
  <ng-container
    *ngIf="itemActionsTpl"
    [ngTemplateOutlet]="itemActionsTpl"
    [ngTemplateOutletContext]="{ $implicit: item, index: index }"
  ></ng-container>
</ng-template>
